import {ValueObject} from '@s-ui/domain'

import {ConfigContext} from '../../config/context/index.js'
import {FilterAggregationSearchValueObject} from './FilterAggregationSearchValueObject.js'

export class FilterAggregationsSearchValueObject extends ValueObject {
  #items
  #name

  constructor({items, name}) {
    super()
    this.#items = items
    this.#name = name
  }

  static createFromListingApi({aggregations, name}) {
    return new FilterAggregationsSearchValueObject({
      items: aggregations.map(({key, totalResults}) =>
        FilterAggregationSearchValueObject.createFromPrimitives({id: key, totalResults})
      ),
      name
    })
  }

  static createFromPrimitives({items, name}) {
    return new FilterAggregationsSearchValueObject({
      items: items.map(({key, name, nestedAggregation, value, totalResults}) =>
        FilterAggregationSearchValueObject.createFromPrimitives({
          id: key,
          name,
          nestedAggregations: nestedAggregation,
          value,
          totalResults
        })
      ),
      name
    })
  }

  static createWithoutRentingOfferType({items, name}) {
    const {OFFER_TYPES_IDS} = ConfigContext.get('vehicleSpecifications')

    const itemsWithoutRentingOfferType = items.map(({nestedAggregation, ...rest}) => {
      const nestedAggregations = nestedAggregation.items.filter(({key}) => key !== OFFER_TYPES_IDS.SUBSCRIPTION)
      const totalResults = nestedAggregations.reduce((acc, {totalResults}) => acc + totalResults, 0)

      return {
        ...rest,
        nestedAggregation: {name: nestedAggregation.name, items: nestedAggregations},
        totalResults
      }
    })

    return new FilterAggregationsSearchValueObject({
      items: itemsWithoutRentingOfferType.map(({key, name, nestedAggregation, totalResults, value}) =>
        FilterAggregationSearchValueObject.createFromPrimitives({
          id: key,
          name,
          nestedAggregations: nestedAggregation,
          value,
          totalResults
        })
      ),
      name
    })
  }

  get items() {
    return this.#items.map(aggregation => aggregation.getValue())
  }

  get name() {
    return this.#name
  }

  getValue() {
    return {
      items: this.items,
      name: this.name
    }
  }

  isCategoryAggregation() {
    return this.name === 'category1Id'
  }

  itemWithHighestTotalResults() {
    const [firstItem] = this.items

    return this.items.reduce(
      (highest, current) => (current.totalResults > highest.totalResults ? current : highest),
      firstItem
    )
  }

  getTotalResults() {
    return this.items.reduce((total, item) => total + item.totalResults, 0)
  }
}
